/**
 * @file: InspectionReportItem.ts
 * @author: eric <xuxiang@zhichetech.com>
 * @copyright: (c) 2019-2020 sichuan zhichetech co., ltd.
 */

import {
  AbnormalLevel,
  OptionValueType,
  SeverityLevel,
  SiteInspectionType,
} from '../enum';
import { MediaInfo } from './MediaInfo';

export interface InspectionReportItemData {
  dataType: string;
  data: string;
}

export enum InspectionReportItemType {
  Normal = 1,
  UserDefined = 2,
  CustomIssue = 3,
}

export interface InspectionReportItem {
  flowId?: string;
  type: InspectionReportItemType;
  label?: string;
  inspectionType: SiteInspectionType;
  positionCode?: string;
  siteId?: number;
  siteCode?: string;
  siteName?: string;
  sitePositionCode?: string;
  siteInfluenceFactor: number;
  siteItemId?: number;
  siteItemName?: string;
  siteItemInfluenceFactor: number;
  defectiveClass?: string;
  abnormalLevel: AbnormalLevel;
  severityLevel: SeverityLevel;
  referenceState?: string;
  maintenanceAdvice?: string;
  resultDataType: OptionValueType;
  resultDataNumberValue?: number;
  resultDataStringValue?: string;
  resultDataUnit?: string;
  resultRemark?: string;
  normalValueType?: OptionValueType;
  normalValueUnit?: string;
  normalResultLabel?: string;
  normalResultLabelFormat?: string;
  normalResultLower?: number;
  normalResultUpper?: number;
  normalResultLowerInclusive?: boolean;
  normalResultUpperInclusive?: boolean;
  abnormalResultLabel?: string;
  abnormalResultLabelFormat?: string;
  abnormalResultLower?: number;
  abnormalResultUpper?: number;
  abnormalResultLowerInclusive?: boolean;
  abnormalResultUpperInclusive?: boolean;
  abnormalDescription?: string;
  data: InspectionReportItemData[];
  medias: MediaInfo[];
}

export interface InspectionReportItemWithKey extends InspectionReportItem {
  reportNo: string;
  key: string;
}
